import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import configurationService from "@/services/configuration";

export const useConfigsStore = defineStore("configs", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchConfigsGrid(companyId) {
    loading.value = true;
    try {
      const res = await configurationService.getConfigs(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function getConfigById(payload) {
    loading.value = true;
    try {
      const res = await configurationService.getConfigById(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addConfig(payload) {
    loading.value = true;
    try {
      const res = await configurationService.addConfig(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editConfig(payload) {
    loading.value = true;
    try {
      const res = await configurationService.editConfig(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteConfig(payload) {
    loading.value = true;
    try {
      const res = await configurationService.deleteConfig(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchConfigsGrid,
    getConfigById,
    addConfig,
    editConfig,
    deleteConfig,
  };
});
